import { useState, useEffect } from "react";
import { Frame, Loading, Header, Input, ValidaUid } from "../components";
import { useNavigate } from "react-router-dom";
import { ValidaForm5 } from "../components/Validacao";
import { db, auth } from "../config/firebase";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { Row, Col, Button } from "react-bootstrap";

const Form5 = () => {
  const [dados, setDados] = useState({});
  const [menor, setMenor] = useState(false);
  const [erro, setErro] = useState({});
  const [loading, setLoading] = useState(true);

  let uid = auth.currentUser?.uid;

  const navigate = useNavigate();

  function handleChange(e) {
    const { name, value } = e.target;

    let novoValor = value;

    //SOMENTE LETRAS
    if (["nomeResponsavel"].includes(name)) {
      novoValor = value.replace(/[^a-zA-ZÀ-ÿ\s]/g, "");
    }

    //SOMENTE NUMEROS
    if (["cpfResponsavel"].includes(name)) {
      novoValor = value.replace(/\D/g, "");
    }

    //LETRAS E NUMEROS
    if (["rgResponsavel"].includes(name)) {
      novoValor = value.replace(/[^a-zA-Z0-9]/g, "");
    }

    setDados((prev) => ({
      ...prev,
      [name]: novoValor.toUpperCase(),
    }));
  }

  const setData = async () => {
    await setDoc(
      doc(db, "furg2026", uid),
      { ...dados, menor: menor },
      { merge: true },
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    setLoading(true);

    if (menor) {
      const err = ValidaForm5(dados);

      if (err) {
        setErro(err);
        setLoading(false);
      } else setData().then(() => navigate("../form6"));
    } else setData().then(() => navigate("../form6"));
  };

  const buscaDados = async () => {
    const uid = await ValidaUid();

    if (uid) {
      const qry = await getDoc(doc(db, "furg2026", uid));

      const data = qry.data();

      const contrato = data?.contrato;

      if (contrato !== "2026") setLoading(false);
      else navigate("../home");
    }
  };

  useEffect(() => {
    buscaDados();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {loading && <Loading />}
      <Header nome={dados?.nome} foto={dados?.urlFoto} />
      <Frame
        body={
          <form
            className="my-4"
            autoComplete="off"
            onSubmit={handleSubmit}
            noValidate
          >
            <div className="row mt-2 d-flex justify-content-center">
              <p>Você já possui 18 anos de idade?</p>

              <div className="d-flex justify-content-between mt-2 w-50">
                <button
                  className="btn btn-danger"
                  type="button"
                  onClick={() => setMenor(true)}
                >
                  Não
                </button>
                <button
                  className="btn btn-primary"
                  onClick={() => setMenor(false)}
                  type="submit"
                >
                  Sim
                </button>
              </div>
            </div>
            {menor && (
              <>
                <hr />
                <Row className="row mt-4 text-start">
                  <Col sm="6">
                    <Input
                      id="nomeResponsavel"
                      label="Nome completo do responsável"
                      type="text"
                      className={erro.nomeResponsavel && "is-invalid"}
                      placeholder="Conforme o documento"
                      value={dados?.nomeResponsavel || ""}
                      onChange={handleChange}
                      erro={erro.nomeResponsavel}
                      autoFocus
                    />
                  </Col>
                  <Col sm="3">
                    <Input
                      id="cpfResponsavel"
                      label="CPF do responsável"
                      type="number"
                      className={erro.cpfResponsavel && "is-invalid"}
                      placeholder="Digite o CPF"
                      value={dados?.cpfResponsavel || ""}
                      onChange={handleChange}
                      erro={erro.cpfResponsavel}
                    />
                  </Col>
                  <Col sm="3">
                    <Input
                      id="rgResponsavel"
                      label="RG do Responsável"
                      type="number"
                      className={erro.rgResponsavel && "is-invalid"}
                      placeholder="Digite o RG"
                      value={dados?.rgResponsavel || ""}
                      onChange={handleChange}
                      erro={erro.rgResponsavel}
                    />
                  </Col>
                </Row>
                <Row className="mt-4">
                  <Col className="d-grid">
                    <Button variant="primary" type="submit">
                      ENVIAR
                    </Button>
                  </Col>
                </Row>
              </>
            )}
          </form>
        }
        title="Dados Cadastrais"
      />
    </>
  );
};

export default Form5;
